import { render, staticRenderFns } from "./ProductIndexPage.vue?vue&type=template&id=46fa32ba&"
import script from "./ProductIndexPage.vue?vue&type=script&lang=js&"
export * from "./ProductIndexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports